import { render } from "./BastImkpModal.vue?vue&type=template&id=1d19dd89"
import script from "./BastImkpModal.vue?vue&type=script&lang=js"
export * from "./BastImkpModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__